import { QueryClient } from '@tanstack/react-query';

import { INVALID_SESSION_MESSAGE, isAbortError } from '../api/http';

/**
 * One cache for the read paths migrated to react-query (Home lists first).
 * 30 s of freshness makes Home → OS → Home instant; a websocket event or a
 * mutation invalidates explicitly when data is known to have changed.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        !isAbortError(error) &&
        !(
          error instanceof Error && error.message === INVALID_SESSION_MESSAGE
        ) &&
        failureCount < 1,
    },
  },
});
